module.exports = __webpack_public_path__ + "img/61614c4.jpg";